module.exports = __webpack_public_path__ + "img/img7.dcce50e2.png";